import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Search, Printer, ShieldCheck, ShieldAlert, User } from "lucide-react";

export default function DriversPage() {
  const [drivers, setDrivers] = useState([]);
  const [q, setQ] = useState("");
  const load = async () => {
    try { const { data } = await api.get("/admin/users?role=driver"); setDrivers(data.users || []); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  useEffect(() => { load(); }, []);
  const filtered = drivers.filter(d => !q.trim() || [d.name, d.email, d.phone, d.driver_profile?.dl_number, d.driver_profile?.home_city].join(" ").toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      <Navbar />
      <div className="max-w-7xl mx-auto px-6 py-10">
        <div className="overline text-[#FF5A00]">DRIVER DATABASE</div>
        <h1 className="font-display font-black text-4xl mt-2 tracking-tight" data-testid="drivers-page">All Northline drivers.</h1>

        <div className="relative max-w-md mt-6">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-zinc-500" />
          <Input value={q} onChange={(e) => setQ(e.target.value)} data-testid="drivers-search"
            placeholder="Search by name, DL, town..."
            className="h-11 pl-10 bg-[#141414] border-[#2A2A2A] rounded-sm focus-visible:ring-[#FF5A00]" />
        </div>

        <div className="mt-6 grid md:grid-cols-2 xl:grid-cols-3 gap-4">
          {filtered.map(d => (
            <div key={d.id} data-testid={`driver-card-${d.id}`} className="p-5 bg-[#141414] border border-[#2A2A2A]">
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-[#FF5A00] text-black font-bold flex items-center justify-center rounded-sm"><User className="w-5 h-5" /></div>
                  <div>
                    <div className="font-display font-bold text-lg">{d.name}</div>
                    <div className="text-xs text-zinc-500 font-mono-ll">{d.phone}</div>
                  </div>
                </div>
                {d.verified
                  ? <span className="inline-flex items-center gap-1 text-[10px] text-emerald-300"><ShieldCheck className="w-3 h-3" /> Verified</span>
                  : <span className="inline-flex items-center gap-1 text-[10px] text-[#FFD700]"><ShieldAlert className="w-3 h-3" /> Pending</span>}
              </div>
              <div className="mt-3 text-xs text-zinc-400 space-y-0.5">
                <div>DL: <span className="text-zinc-200 font-mono-ll">{d.driver_profile?.dl_number || "—"}</span></div>
                <div>Home: {d.driver_profile?.home_city || "—"}, {d.driver_profile?.home_state || "—"}</div>
                <div>Experience: {d.driver_profile?.experience_years || 0} yrs</div>
              </div>
              <div className="mt-4 pt-4 border-t border-[#2A2A2A]">
                <Link to={`/prints/driver-card/${d.id}`} target="_blank" rel="noopener noreferrer">
                  <Button size="sm" variant="outline" data-testid={`driver-card-print-${d.id}`}
                    className="w-full rounded-sm border-[#2A2A2A] hover:bg-[#FF5A00]/10 text-[#FF5A00]">
                    <Printer className="w-3 h-3 mr-1" /> Performance card
                  </Button>
                </Link>
              </div>
            </div>
          ))}
          {filtered.length === 0 && <div className="col-span-full p-12 border border-dashed border-[#2A2A2A] text-center text-zinc-500">No drivers found.</div>}
        </div>
      </div>
    </div>
  );
}
